type NotifyType = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark';

export const Notify = {
  show(message: string, type: NotifyType = 'info'): void {
    const alert = document.createElement('div');
    alert.className = `alert alert-${type} alert-dismissible fade show position-fixed`;
    alert.style.cssText = 'top: 20px; right: 20px; z-index: 9999; min-width: 300px;';
    alert.innerHTML = `
      ${message}
      <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
    `;
    document.body.appendChild(alert);

    setTimeout(() => {
      alert.remove();
    }, 5000);
  },

  success(message: string): void {
    this.show(message, 'success');
  },

  error(message: string): void {
    this.show(message, 'danger');
  },

  warning(message: string): void {
    this.show(message, 'warning');
  },

  info(message: string): void {
    this.show(message, 'info');
  },
};
